import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ERROR_MESSAGES_MAP, ERROR_MESSAGE_MAP_TOKEN } from '../../../data/error-messages.map';

@Component({
  selector: 'app-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
  imports: [CommonModule],
  standalone: true,
})
export class InputErrorComponent {
  errorStrings: Array<keyof typeof ERROR_MESSAGES_MAP> = [];

  constructor(@Inject(ERROR_MESSAGE_MAP_TOKEN) public errorsMap: typeof ERROR_MESSAGES_MAP) {}

  @Input({ required: true }) set errors(errs: ValidationErrors) {
    this.errorStrings = Object.keys(errs).map((err) => err as keyof typeof ERROR_MESSAGES_MAP);
  }
}
